import React from 'react';
import UserDashboard from '../../UserDashboard';



export default function FXCentre () {
    return (
        <UserDashboard>
        </UserDashboard>
    )
}